import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation  } from 'react-router-dom';

import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';

function TreeSubscription() {
  
 const navigate = useNavigate();
 const location = useLocation();
  
  const queryParams = new URLSearchParams(location.search);
  const verifyCode = queryParams.get("verifyCode");
 
  const { data: userCode, isLoadingCode, isErrorCode } = useQuery({
    queryKey: ["user-code", verifyCode], // ✅ include in cache key
    queryFn: () =>
      axios
        .get(`${API_URL}/tree-subscription-check-code-api?verifyCode=${verifyCode}`, { 
          withCredentials: true 
        })
        .then((response) => response.data),
    enabled: !!verifyCode, //only run if verifyCode exists
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: "always",
  refetchOnWindowFocus: "always",
  });

  
  
  const { data: plans, isLoading, isError } = useQuery({
    queryKey: ["subscription-plans"],
    queryFn: () =>
      axios
        .get(`${API_URL}/tree-subscription-plans-api`, { withCredentials: true })
        .then((response) => response.data),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: "always",
  refetchOnWindowFocus: "always",
  });



  if (isLoading) return (
    <div className="loadingspinnerDiv" style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f4f7f5 0%, #e8f0ea 100%)'
    }}>
      <div className="loadingspinner" style={{
        width: '48px', height: '48px', borderRadius: '50%',
        border: '4px solid #e8f0ea',
        borderTopColor: '#75B437',
        borderRightColor: '#184A2C',
        animation: 'spin 0.9s linear infinite'
      }}></div>
    </div>
  );
  
  if (isError) return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #f4f7f5 0%, #e8f0ea 100%)',
      fontFamily: "'DM Sans', sans-serif"
    }}>
      <p style={{ color: '#184A2C', fontWeight: 600 }}>Error fetching plans</p>
    </div>
  );
  
  return (
    <div className="main-wrapper" style={{
      background: 'linear-gradient(135deg, #f4f7f5 0%, #e8f0ea 100%)',
      fontFamily: "'DM Sans', sans-serif",
      padding: '1rem',
      minHeight: '100vh'
    }}>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
  
      <div className='content container-fluid'>
  
        {userCode?.Status === "Success" ? (
          <>
            

            {/* Welcome banner */}
<div style={{
  maxWidth: '640px',
  margin: '0 auto 2rem',
  background: '#ffffff',
  borderRadius: '24px',
  overflow: 'hidden',
  boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.15)',
  animation: 'fadeInUp 0.5s ease-out'
}}>
  <div style={{
    background: 'linear-gradient(135deg, #184A2C 0%, #0f3620 100%)',
    padding: '2rem 1.5rem 1.5rem',
    textAlign: 'center'
  }}>

    {/* Logo badge — same circular holder language as the other icons */}
    
      <img
        src="img/logo_1.png"
        alt="Oret Africa"
        height="34"
        style={{
          filter: 'brightness(0) invert(1)',
          transition: 'transform 0.3s ease'
        }}
        onMouseEnter={(e) => e.target.style.transform = 'scale(1.08)'}
        onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
      />
     

    {/* Thin divider so logo and message read as two distinct zones */}
    <div style={{
      width: '32px',
      height: '2px',
      
      margin: '0 auto 0.9rem',
      borderRadius: '2px'
    }}></div>

    <p className='em-hero-label' >
      Tree Subscription
    </p>

    <p style={{
      color: 'rgba(255,255,255,0.9)',
      fontSize: '0.95rem',
      margin: 0,
      lineHeight: 1.5
    }}>
      Hello <strong style={{ color: '#ffffff' }}>{userCode.user.name} {userCode.user.last_name}</strong>,
      kindly select your plan below
    </p>
  </div>
</div>

  
            <div className="plans-grid" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
              gap: '1.5rem',
              maxWidth: '1100px',
              margin: '0 auto',
              padding: '0 0.5rem'
            }}>
              {Array.isArray(plans) && plans.length > 0 ? (
                plans.map((plan, i) => (
                  <div
                    key={plan.id}
                    className="plan-card"
                    style={{
                      background: '#ffffff',
                      borderRadius: '24px',
                      overflow: 'hidden',
                      boxShadow: plan.recommended
                        ? '0 20px 40px -12px rgba(255, 102, 0, 0.25)'
                        : '0 20px 40px -12px rgba(0, 0, 0, 0.12)',
                      border: plan.recommended ? '2px solid #ff6600' : '1px solid #e5ede8',
                      animation: `fadeInUp 0.5s ease-out ${i * 0.08}s both`,
                      display: 'flex',
                      flexDirection: 'column',
                      position: 'relative'
                    }}
                  >
                    {plan.recommended && (
                      <span style={{
                        position: 'absolute', top: '14px', right: '-32px',
                        transform: 'rotate(40deg)',
                        background: '#ff6600', color: '#fff',
                        fontSize: '0.65rem', fontWeight: 700,
                        letterSpacing: '0.05em', textTransform: 'uppercase',
                        padding: '0.3rem 2.5rem', zIndex: 1
                      }}>
                        Most Chosen
                      </span>
                    )}
  
                    {/* Card header, mirrors the email card's icon-in-circle header */}
                    <div style={{
                      background: 'linear-gradient(135deg, #184A2C 0%, #0f3620 100%)',
                      padding: '1.5rem 1.25rem 1rem',
                      textAlign: 'center'
                    }}>
                       

                      <h3 style={{ color: 'white', margin: 0, fontSize: '1.1rem', fontWeight: 600 }}>
                        {plan.title}
                      </h3>
                    </div>
  
                    <div style={{ padding: '1.25rem', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
  
                      {/* Price box, styled like the email box */}
                      <div style={{
                        background: '#f8fcf9',
                        borderRadius: '12px',
                        padding: '0.85rem',
                        marginBottom: '1rem',
                        border: '1px solid #e5ede8',
                        textAlign: 'center'
                      }}>
                        <p style={{ margin: '0 0 0.2rem', color: '#666', fontSize: '0.7rem' }}>
                          Subscription price
                        </p>
                        <p style={{ margin: 0, color: '#184A2C', fontSize: '1.35rem', fontWeight: 700 }}>
                          KES {plan.price} <small style={{ fontSize: '0.75rem', fontWeight: 500, color: '#75B437' }}>/ {plan.period}</small>
                        </p>
                      </div>
  
                      <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1.25rem', flexGrow: 1 }}>
                        {(Array.isArray(plan.features) ? plan.features : [plan.features]).map((f, idx) => (
                          <li key={idx} style={{
                            display: 'flex', alignItems: 'flex-start', gap: '8px',
                            fontSize: '0.85rem', color: '#184A2C', marginBottom: '0.55rem'
                          }}>
                            <span style={{
                              width: '7px', height: '7px', borderRadius: '50%',
                              background: '#75B437', marginTop: '6px', flexShrink: 0
                            }}></span>
                            {f}
                          </li>
                        ))}
                      </ul>
  
                      <button
                        onClick={() =>
                          navigate("/tree-subscription-now", {
                            state: { planId_name: plan.id, verifyCode: verifyCode },
                          })
                        }
                        style={{
                          width: '100%',
                          padding: '0.7rem',
                          borderRadius: '40px',
                          border: plan.recommended ? 'none' : '1.5px solid #184A2C',
                          background: plan.recommended ? '#ff6600' : 'transparent',
                          color: plan.recommended ? '#ffffff' : '#184A2C',
                          fontWeight: 600,
                          fontSize: '0.85rem',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          if (plan.recommended) e.target.style.background = '#e55a00';
                          else { e.target.style.background = '#184A2C'; e.target.style.color = '#fff'; }
                        }}
                        onMouseLeave={(e) => {
                          if (plan.recommended) e.target.style.background = '#ff6600';
                          else { e.target.style.background = 'transparent'; e.target.style.color = '#184A2C'; }
                        }}
                      >
                        {plan.cta}
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ gridColumn: '1 / -1', textAlign: 'center', color: '#184A2C', opacity: 0.6 }}>
                  No subscription plans found
                </p>
              )}
            </div>
  
            {/* Footer note, same minimal style as the email card footer */}
            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <p style={{ fontSize: '0.7rem', color: '#8aa899', margin: 0 }}>
                <i className="fas fa-headset me-1"></i> Need help? Contact support@oret.africa
              </p>
            </div>
          </>
        ) : (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
            <div style={{
              maxWidth: '460px',
              width: '100%',
              background: '#ffffff',
              borderRadius: '24px',
              overflow: 'hidden',
              boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.2)',
              animation: 'fadeInUp 0.5s ease-out',
              textAlign: 'center'
            }}>
              <div style={{
                background: 'linear-gradient(135deg, #184A2C 0%, #0f3620 100%)',
                padding: '1.75rem 1.5rem 1.25rem'
              }}>
                <div style={{
                  width: '60px', height: '60px', margin: '0 auto 0.75rem',
                  background: '#fdece0', borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                  <i className="fa fa-exclamation-triangle" style={{ fontSize: '24px', color: '#ff6600' }}></i>
                </div>
                <h3 style={{ color: 'white', margin: 0, fontSize: '1.2rem', fontWeight: 600 }}>
                  Link Expired
                </h3>
              </div>
              <div style={{ padding: '1.5rem' }}>
                <p style={{ color: '#666', fontSize: '0.85rem', margin: 0 }}>
                  Sorry, the link has expired. Kindly resend the notification to continue.
                </p>
              </div>
            </div>
          </div>
        )}
  
        <div className='row mt-4' style={{ marginTop: '5%' }}></div>
  
      </div>
<style>{`
      .em-hero-label { display: inline-block; background: rgba(255,255,255,0.12); border: 0.5px solid rgba(255,255,255,0.2); color: #a8e6b8; font-size: 11px; letter-spacing: 2px; text-transform: uppercase; font-weight: 500; padding: 5px 14px; border-radius: 20px; margin-bottom: 18px; }
`}</style>
    </div>
  );
  }
  
  export default TreeSubscription;